import type { Session } from 'next-auth'
import type { AnnouncementBar } from '@/gen/sanity/schema'
import type { SanityHeader } from '@/interfaces/SanityHeader'

export function getAnnouncementBarFromSanityLayout(
  header: SanityHeader,
  session: Session | null
): AnnouncementBar | undefined {
  if (header?.announcementBar && session !== undefined) {
    const announcementBar = header.announcementBar[0]
    if (
      announcementBar.userContext &&
      ((session && announcementBar.userContext.includes('logged')) ||
        (!session && announcementBar.userContext.includes('anonymous')))
    ) {
      return announcementBar
    }
  }

  return undefined
}
